export { default } from './svg/copy.svg';
